<template>
    <!-- Popover -->
    <div
        :id="id"
        class="hs-tooltip inline-block"
        :class="orientacion[disparador]+' '+placement[posicion]"
        >
        <div class="hs-tooltip-toggle block text-center">
            <slot name="title">
                <button type="button" class="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none dark:text-blue-500 dark:hover:text-blue-400 dark:focus:text-blue-400">
                    Más información
                </button>
            </slot>
            <div class="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible hidden opacity-0 transition-opacity absolute invisible z-[999] max-h-[70vh] overflow-y-auto overscroll-contain max-w-xs w-full bg-white border border-gray-100 text-start rounded-xl shadow-md after:absolute after:top-0 after:-start-4 after:w-4 after:h-full dark:bg-neutral-800 dark:border-neutral-700" role="tooltip">
                <slot name="content">
                    <div class="p-4">
                        Contenido
                    </div>
                </slot>
            </div>
        </div>
    </div>
<!-- End Popover -->
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, type PropType } from 'vue';
import { generarUuid } from '@/modules/Core/usings/generales'
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  posicion:{
    type: String as PropType<'top' | 'left' | 'right' | 'bottom'>,
    default:'top'
  },
  disparador:{
    type: String as PropType<'hover' | 'click' | 'focus'>,
    default:'hover'
  }
});
//const description = ref(props.description)
const orientacion = {
    hover :'[--trigger:hover]',
    click:'[--trigger:click]',
    focus:'[--trigger:focus]'
}
const placement ={
    top:'',
    left:'[--placement:left]',
    right:'[--placement:right]',
    bottom:'[--placement:bottom]',
}
const idComponent = props?.id ? props.id : generarUuid()
let element
onMounted(()=>{
  if(window.HSTooltip && document.getElementById(idComponent)){
    element = new window.HSTooltip(document.getElementById(idComponent))
  }
})
onBeforeUnmount(()=>{
  if(element){
    element.destroy()
  }
})
</script>
